import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnamneseConfiguracaoRoutingModule } from './anamnese-configuracao-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AnamneseConfiguracaoRoutingModule
  ]
})
export class AnamneseConfiguracaoModule { }
